import { useQuery } from "@tanstack/react-query";
import { api } from "../config";
import { MOLONI_BASE_PATH } from "./moloniApi";

export const getOrderInvoices = async (orderId: number | string | null | undefined) => {
    if (!orderId) return null;

    const response = await api({
        method: "GET",
        url: MOLONI_BASE_PATH,
        params: {
            order_id: orderId,
        },
    });

    return response.data;
};

export const useOrderInvoice = (orderId: number | string | null | undefined) => {
    return useQuery({
        queryKey: ["order-invoice", orderId],
        queryFn: () => getOrderInvoices(orderId),
        enabled: !!orderId,
        staleTime: Infinity,
    });
};

